import React from 'react';

const DBUserContext = React.createContext(null);

export default DBUserContext;
